import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    tomselect = null
    originalOnChange = null

    connect() {
        hidePreloader()

        this.originalOnChange = this.element.onchange
        this.initializeTomSelect()
    }

    disconnect() {
        if (this.tomselect) {
            this.tomselect.destroy()
            this.tomselect = null
        }
    }

    initializeTomSelect() {
        if (this.element.tomselect) {
            return
        }

        const options = {
            render: {
                option: (data, esc) => `
                    <div class="confrere-ad-mission-option d-flex align-items-center justify-content-center">
                        <span>${esc(data.text)}</span>
                    </div>
                `,
                item: (data, esc) => `
                    <div class="confrere-ad-mission-item d-flex align-items-center justify-content-center">
                        <span>${esc(data.text)}</span>
                    </div>
                `,
            },
            controlInput: null,
            dropdownParent: 'body',
            allowEmptyOption: true,
            hideSelected: true,
            onChange: () => {
                showPreloader()

                // Fire the native change event for Live Components to detect
                const event = new Event('change', { bubbles: true })
                this.element.dispatchEvent(event)

                // Call original onchange handler if it exists (for inline handlers)
                if (this.originalOnChange) {
                    this.originalOnChange.call(this.element, event)
                }
            },
        }

        this.tomselect = new TomSelect(this.element, options)

        if (this.tomselect.wrapper) {
            this.tomselect.wrapper.classList.add('confrere-ad-mission-select')
            this.tomselect.dropdown.classList.add('confrere-ad-mission-custom-select')
        }
    }
}
